import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { ReportDocument } from "@/components/ReportDocument";
import { ArrowLeft, Download, Loader2 } from "lucide-react";

export default function ReportView() {
  const { id, rid } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const endpoint = rid ? `/reports/${rid}` : `/projects/${id}/report`;

  useEffect(() => {
    api.get(endpoint).then((r) => setReport(r.data)).catch(() => navigate("/dashboard"));
  }, [endpoint, navigate]);

  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(id ? `/projects/${id}` : "/reports");
  };

  if (!report) return <div className="flex min-h-screen items-center justify-center bg-neutral-900"><Loader2 className="h-6 w-6 animate-spin text-[#c5a24a]" /></div>;

  return (
    <div className="min-h-screen bg-neutral-900 py-8">
      <div className="no-print mx-auto mb-6 flex max-w-[8.5in] items-center justify-between px-2">
        <button onClick={goBack} data-testid="report-back-btn" className="flex items-center gap-1.5 text-sm font-semibold text-neutral-400 hover:text-[#c5a24a]"><ArrowLeft className="h-4 w-4" /> Back</button>
        <button onClick={() => window.print()} data-testid="download-pdf-btn" className="gold-gradient flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-[#121212] transition-opacity hover:opacity-90"><Download className="h-4 w-4" /> Download PDF</button>
      </div>
      {report._published && <div className="no-print mx-auto mb-3 max-w-[8.5in] px-2 text-xs text-neutral-500">Version {report._published.version} · {report._published.date} · {report._published.description}</div>}
      <ReportDocument report={report} />
    </div>
  );
}
